import React from "react";
import { withStyles } from "@material-ui/core/styles";
import {
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  ListItemSecondaryAction,
  Avatar,
  Typography,
  Badge
} from "@material-ui/core";
import Group from "@material-ui/icons/Group";
import myStyles from "./Style";

function getCount(chat, userID) {
  return chat.unread[userID].count;
}
function GroupTab(props) {
  const { classes, groups, openChat, tabIndex, user } = props;

  return (
    <List hidden={tabIndex !== 1} className={classes.scrollable}>
      {groups.map((group, index) => (
        <ListItem
          divider
          button
          key={index}
          onClick={() => openChat(group, "group")}
        >
          <ListItemAvatar>
            <Avatar src={group.ppURL}>
              <Group />
            </Avatar>
          </ListItemAvatar>
          <ListItemText
            primary={group.name}
            secondary={<Typography noWrap>{group.creator}</Typography>}
          />

          <ListItemSecondaryAction>
            <Badge
              badgeContent={getCount(group, user.uid)}
              color="secondary"
            ></Badge>
          </ListItemSecondaryAction>
        </ListItem>
      ))}
    </List>
  );
}

export default withStyles(myStyles)(GroupTab);
